var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"arrow animated bounce container",on:{"click":function($event){return _vm.scrollToContent()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }